"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptedFilesDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_jss_1 = __importDefault(require("react-jss"));
const acceptedFilesDescription_style_1 = __importDefault(require("./acceptedFilesDescription.style"));
const AcceptedFilesDescription = ({ classes, fileExtensionWhitelistMap, responsive, filesLength }) => {
    if (!fileExtensionWhitelistMap)
        return null;
    const fileExtensionsWhiteList = Object.entries(fileExtensionWhitelistMap);
    return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, style: { marginBottom: responsive && filesLength > 0 ? '14px' : 0 }, "data-is-responsive": responsive }, { children: [jsx_runtime_1.jsx("h5", { children: "accepted file types" }, void 0),
            jsx_runtime_1.jsx("ul", { children: fileExtensionsWhiteList.map(([category, extensionsList]) => {
                    const extensionLength = extensionsList.length;
                    return (jsx_runtime_1.jsxs("li", { children: [category, extensionsList.map((extension, index) => {
                                if (index < 3)
                                    return jsx_runtime_1.jsxs("span", { children: [extension, ","] }, extension);
                                if (index === 3 && extensionLength > 3)
                                    // If we have more than 4 extensions, add the rest of the array in the html title attribute (aka tooltip)
                                    return (jsx_runtime_1.jsx("span", Object.assign({ "data-has-more-extension": extensionLength > 4, title: extensionsList.slice(index + 1) }, { children: extension }), extension));
                                return null;
                            })] }, category));
                }) }, void 0)] }), void 0));
};
exports.AcceptedFilesDescription = AcceptedFilesDescription;
exports.default = react_jss_1.default(acceptedFilesDescription_style_1.default)(react_1.default.memo(exports.AcceptedFilesDescription));
//# sourceMappingURL=index.js.map